module.exports = __webpack_public_path__ + "static/img/0008.4c9ac8e2.png";